import {
  Checkbox,
  FormControlLabel,
  IconButton,
  Paper,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import _ from 'lodash';
import { TetraPrimaryButton } from '../../../components/style/ButtonStyle';
import {
  PrettyScrollbarTableWrap,
  PrimaryBorderTable,
} from '../../../components/style/TableStyle';
import {
  CountingText,
  ListTitleText,
} from '../../../components/style/TextStyle';
import {
  CancelIcon,
  DownloadIcon,
} from '../../../layouts/dashboard/nav/IconButton';

import { useState } from 'react';
import { TableBackground } from '../../../components/style/CommonStyle';
import { useAuthDownload } from '../../../hooks/useAuthAxios';
import { fDate } from '../../../utils/formatTime';
import { selectedHeader } from './FacilityListHeader';
import { OwnershipTypeListLabel } from '../../../utils/enum';
import { sliceSerialNumber } from '../../../utils/helper';

export default function SelectedListCard({
  selectedList,
  setSelectTable,
  selectTable,
}: any) {
  const [headerTable, setHeaderTable] = useState(_.keyBy(selectedHeader, 'id'));

  return (
    <TableBackground
      flex={1}
      spacing={3}
      sx={{ width: '100%', overflow: 'auto' }}
    >
      <ListTitleText>선택된 리스트</ListTitleText>
      <Stack
        direction="row"
        sx={{ w: '100%' }}
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack>
          <CountingText>총 {selectedList?.length}건 선택</CountingText>
        </Stack>
        <Stack>
          <DownloadExcelButton
            selectedList={selectedList}
            headerTable={headerTable}
          />
        </Stack>
      </Stack>

      <PrettyScrollbarTableWrap>
        <TableContainer
          component={Paper}
          sx={{
            mt: '16px !important',
            borderRadius: '10px',
            maxWidth: '533px',
            maxHeight: 'calc(100vh - 472px)',
          }}
        >
          <PrimaryBorderTable sx={{ width: '3130px' }} size="small">
            <TableHead>
              <TableRow>
                <TableCell align="center" sx={{ width: 24 }} />
                {_.map(selectedHeader, t => (
                  <TableCell align="center" key={t.id}>
                    <FormControlLabel
                      value="end"
                      control={
                        <Checkbox
                          size="small"
                          checked={!!headerTable[t.id as keyof Object] || false}
                          onChange={() => {
                            if (headerTable[t.id as keyof Object]) {
                              setHeaderTable(_.omit(headerTable, [t.id]));
                            } else {
                              setHeaderTable({
                                ...headerTable,
                                [t.id]: t,
                              });
                            }
                          }}
                        />
                      }
                      label={<CountingText>{t?.label}</CountingText>}
                      labelPlacement="end"
                    />
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {_.map(selectedList, (selected: any) => (
                <TableRow key={selected.facilityId}>
                  <TableCell align="center" sx={{ p: 0 }}>
                    <IconButton
                      onClick={() =>
                        setSelectTable(
                          _.omit(selectTable, [selected.facilityId]),
                        )
                      }
                    >
                      <CancelIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell align="center">
                    {sliceSerialNumber(selected?.serialNumber) || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {selected?.category || '-'}
                  </TableCell>
                  <TableCell align="center">{selected?.title || '-'}</TableCell>
                  <TableCell align="center">
                    {selected?.subCategory || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {selected?.addressName || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {selected?.addressNote || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {selected?.inspectionScore || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {fDate(selected?.dateOfInstall, 'yyyy-MM-dd') || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {_.get(
                      OwnershipTypeListLabel,
                      selected?.ownershipType,
                      '-',
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {selected?.usedAs === null ? '-' : selected?.usedAs || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {selected?.occupyingSpace || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {selected?.installCostNation || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {selected?.installCostCity || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {selected?.installCostDistrict || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {selected?.installedDepartment || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {selected?.managingDepartment || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {selected?.maintenanceDepartment || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {selected?.contactNumber || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {selected?.consignedOrgTitle || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {fDate(selected?.consignedStartDate, 'yyyy-MM-dd') || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {fDate(selected?.consignedEndDate, 'yyyy-MM-dd') || '-'}
                  </TableCell>
                  <TableCell align="center">
                    {selected?.notes === null ? '-' : selected?.notes || '-'}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </PrimaryBorderTable>
        </TableContainer>
      </PrettyScrollbarTableWrap>
    </TableBackground>
  );
}

function DownloadExcelButton({ selectedList, headerTable }) {
  const columns = _.values(headerTable);
  const columnIds = _.map(columns, 'id');
  const facilitiesIds = _.map(selectedList, 'facilityId');

  const [download] = useAuthDownload('시설물 리스트', {
    method: 'POST',
    url: `/api/v1/facility/downloadSelected`,
    data: {
      facilities: facilitiesIds,
      columns: columnIds,
    },
  });
  return (
    <TetraPrimaryButton
      startIcon={<DownloadIcon />}
      onClick={() => {
        download();
      }}
    >
      시설물 리스트 다운로드
    </TetraPrimaryButton>
  );
}
